import { EnterpriseModel } from "../management/enterprise.model";

export class DocumentSupportModel {
  documentSupportId: number = 0;
  branchId: number = 0;
  enterpriseId: number = 0;
  enterprise: EnterpriseModel = new EnterpriseModel();
  bussinessDocumentsTypeId: number = 0;
  bussinessDocumentsResolutionId: number = 0;  // Se llena en el backend
  consecutive: number = 0; // Se llena en el backend
  dateDocument: Date = new Date;
  rentalPeriodId: number = 0; // Se llena en el backend
  providerId: number = 0;
  active: boolean = true;
  observation: string | null = null;
  creditNotesValue: number = 0;
  residueValue: number = 0;
  totalValue: number = 0;
  swCopied: boolean = false;
  documentSupportOriginId: number | null = null;
  accountingInterfaceId: number | null = null;
  electronicInvoiceInterfaceId: number | null = null;
  cuds: string | null = null; //Se llena en el backend
  validationDian: number | null = null;
  dateValidationDian: Date | null = null;
  statusDianCode: number | null = null;
  statusDianDescription: string | null = null;
  technologicalProviderMessageCode: string | null = null;
  technologicalProviderMessageDescription: string | null = null;
  xmlName: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;

  //Variables usadas solo del lado del FrontEnd
  qrData: string = '';
}
